import { useMemo, useState } from "react";
import StyledTooltip from "../../styledTooltip";
import { SendIcon } from "Icons/SendIcon";
import { InfoTooltipContent } from "pages/gpt/components/chatContent/components/InfoTooltipContent";
import { getMatchedSuggestions } from "constants/chat.constants";

import { InputIconButton, StyledInput } from "./styles";

import Stack from "@mui/material/Stack";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { gaClickCallback } from "helpers/common";

export const ChatInput = ({
  label,
  name,
  onChange,
  handleKeyDown,
  handleSetExampleMessage,
  message,
  handleSubmit,
}) => {
  const [hovered, setHovered] = useState(false);
  const [inputFocused, setInputFocused] = useState(false);
  const matchedSuggestions = useMemo(() => getMatchedSuggestions(message), [message]);
  const hasMatches = matchedSuggestions.length > 0;
  const showSuggestions = hasMatches && inputFocused;
  const tooltipOpen = showSuggestions || hovered;
  const tooltipSuggestions = showSuggestions ? matchedSuggestions : undefined;

  return (
    <Stack direction="row" gap="24px" px="40px">
      <StyledInput
        multiline
        minRows={1}
        maxRows={3}
        name={name}
        value={message}
        placeholder={label}
        onKeyDown={handleKeyDown}
        onChange={onChange}
        onFocus={() => setInputFocused(true)}
        onBlur={() => setInputFocused(false)}
        sx={{
          "& textarea": {
            p: "0 !important",
          },
        }}
        InputProps={{
          startAdornment: (
            <StyledTooltip
              title={
                <InfoTooltipContent
                  handleSetExampleMessage={handleSetExampleMessage}
                  suggestions={tooltipSuggestions}
                />
              }
              placement="top"
              arrow
              open={tooltipOpen}
              onOpen={() => setHovered(true)}
              onClose={() => setHovered(false)}
              TransitionProps={{ timeout: { enter: 200, exit: 0 } }}
              PopperProps={{
                modifiers: [{ name: "offset", options: { offset: [362, 0] } }],
              }}
            >
              <InfoOutlinedIcon sx={{ mr: "10px", mt: "0.5px" }} fontSize="small" />
            </StyledTooltip>
          ),
        }}
      />

      <InputIconButton
        disabled={!message}
        onClick={() =>
          gaClickCallback({
            label: `user sent message: ${message}`,
            callback: () => handleSubmit(),
          })
        }
      >
        <SendIcon />
      </InputIconButton>
    </Stack>
  );
};
